<template>
  <div style="width:100%;">
    <div v-if="payCreditCard" class="row">
      <div class="col-md-6">
        <stripe
          v-bind="stripeBindings"
          @handle-submit="payWithStripe($event)"
        />
      </div>
    </div>
    <form
      v-else
      class="tdesk-form"
      @submit.prevent="handleSubmit()"
    >
      <checkbox
        :id="'confirmation'"
        :required="true"
        :label="labelText"
        @input="confirmation = $event"
      />

      <div v-if="payByInvoice && order.course.booking_type === 'public_booking'" class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="purchase_order_number">Purchase Order Number</label>
            <!-- eslint-disable-next-line vue/no-mutating-props -->
            <input v-model="order.purchaseOrderNumber" type="text" name="purchase_order_number">
          </div>
        </div>
      </div>

      <button
        id="submit"
        type="submit"
        class="tdesk-primary-button"
        :disabled="disableButton"
      >
        <i class="fas fa-check-circle" />
        {{ buttonText }}
      </button>
    </form>
  </div>
</template>

<script>
  import Checkbox from '../../tdesk/checkbox';
  import Stripe from './stripe_payment';

  export default {
    components: {Checkbox, Stripe},
    props: {
      assets: {
        required: true,
        type: Object,
      },
      order: {
        required: true,
        type: Object,
      },
      paymentErrors: {
        required: true,
        type: Array,
      },
      domain: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        confirmation: false,
      };
    },
    computed: {
      errors() {
        return this.paymentErrors;
      },
      stripeBindings() {
        return {
          'total': this.order.total,
          'order': this.order,
          'logo-url': this.assets.stripe_logo,
          'payment-errors': this.errors,
          'course-title': this.courseTitle,
          'stripe-public-key': this.domain.stripe_public_key,
        };
      },
      courseTitle() {
        return `${this.order.course.unit_code} - ${this.order.course.unit_descriptor}`;
      },
      disableButton() {
        return !this.confirmation;
      },
      pageTitle() {
        if (this.payOnDay) { return 'Pay on the day'; }
        if (this.payCreditCard) { return 'Secure credit card payment'; }
        if (this.payByInvoice) { return 'Pay by invoice'; }

        return undefined;
      },
      payOnDay() {
        return this.order.paymentMethod === 'pay_on_day';
      },
      payCreditCard() {
        return this.order.paymentMethod === 'credit_card_payment';
      },
      payByInvoice() {
        return this.order.paymentMethod === 'invoice';
      },
      labelText() {
        if (this.payOnDay) { return 'I acknowledge that I will bring full payment on the day of training, or contact the training provider to discuss payment arrangements.'; }
        if (this.payByInvoice) { return `I am authorised to proceed with this transaction on behalf of ${this.order.client.name}`; }
        return undefined;
      },
      buttonText() {
        if (this.payOnDay) { return 'Confirm payment arrangements'; }
        if (this.payByInvoice) { return `Request invoice for $${parseFloat(this.order.total).toFixed(2)}`; }
        return undefined;
      },
    },
    mounted() {
      $('input:enabled').first().focus();
      this.$emit('change-page-title', this.pageTitle);
    },
    methods: {
      addToErrors(error) {
        this.errors = error;
      },
      handleSubmit() {
        this.$emit('finalize');
      },
      payWithStripe(tokenId) {
        this.$emit('set-stripe-token', tokenId);
        this.$nextTick(() => this.handleSubmit());
      },
    },
  };
</script>